import React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"

import { Container } from "shards-react"

import CsecCapeApply from "../../forms/csecCapeApply"

function ApplicationForm(props) {
  return (
    <Layout countryCode={props.pageContext.countryCode || "JM"}>
      <Seo
        title="Apply Now"
        description=""
        countryCode={props.pageContext.countryCode || "JM"}
      />
      <br />
      <br />
      <Container>
        <CsecCapeApply countryCode={props.pageContext.countryCode || "JM"} />
      </Container>
    </Layout>
  )
}

export default ApplicationForm
